import React from 'react';
import '../cfcDashboard/DashboardHeader.scss';

/**
 * CurrentCollectionDashboardLoading Component
 * 
 * A placeholder loading component for the current collection dashboard section.
 * It renders a styled div to indicate loading while data is being fetched.
 *
 * @component
 * @memberof Components
 * @example
 * return (
 *   <CurrentCollectionDashboardLoading />
 * )
 *
 * @returns {JSX.Element} A div styled as a loading placeholder for the collection dashboard.
 */

const CurrentCollectionDashboardLoading = () => {
    return (
        <div className="dashboard-header" style={{ width: 'auto', backgroundColor: '#edeff2', height: '35vh' }}>
        </div>
    )
};

export default CurrentCollectionDashboardLoading;
